import React from 'react'
import background from "../../../images/students/bg-gradient.webp";
import banner from "../../../images/students/banner.webp";
import { GoStarFill } from "react-icons/go";
import { LuCircleCheckBig, LuRocket, LuShield, LuTable2, LuTrendingUp, LuZap } from 'react-icons/lu';

export default function Banner() {

    return (
        <div className='bg-gradient-to-b from-[#F0FDF4] to-[#FFFFFF] xl:pt-[150px] mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] lg:pb-[40px] relative z-0 w-full overflow-hidden'>
            <img src={background} alt='background' loading='lazy' className='absolute inset-0 z-[0] w-full' />
            <div className='relative z-10'>
                <div className='flex justify-center md:justify-between items-center'>
                    <div className='hidden md:flex'></div>
                    <div className='bg-[#FEFCE8] w-max border border-[#FEF9C2] rounded-full px-[15px] md:px-[25px] py-[9px] flex gap-[8px] items-center text-[#894B00] font-bold text-[10px] md:text-[14px]' style={{ boxShadow: "0px 1px 3px 0px #0000001A" }}>
                        <GoStarFill className='size-[14px] md:size-[20px] text-[#D08700]' />
                        <p>INDIA'S FIRST STUDENTS SKILLING SYSTEM</p>
                    </div>
                    <div className='bg-[#FFFFFF] border border-[#E8E9EB] size-[54px] rounded-[12px] hidden md:flex justify-center items-center -rotate-12'>
                        <LuRocket size={28} className='text-[#FF6900]' />
                    </div>
                </div>
                <div className='w-full md:w-11/12 mx-auto grid xl:grid-cols-2 mt-[16px] md:mt-[32px]'>
                    <div className='text-[#101828] text-center xl:text-start'>
                        <h1 className='font-bold text-[24px] md:text-[70px]'>Find Your Path.</h1>
                        <h2 className='bg-clip-text text-transparent bg-gradient-to-r from-[#155DFC] to-[#9810FA] font-bold text-[28px] md:text-[78px]'>Build Real Skills.</h2>
                        <h2 className='font-bold text-[22px] md:text-[54px]'>Become Independent.</h2>
                        <div className='mt-[10px] md:mt-[15px] font-medium text-[#3C3C4399] text-[12px] md:text-[24px]'>
                            <p>Not a course. Not a coaching center. <span className='text-[#34C759]'>A Skilling System.</span></p>
                            <p className='font-normal mt-[5px] md:mt-[10px] text-[#4A5565]'>Built by real developers, designers & founders who <br className='hidden md:block' /> work in the industry. We don't just teach theory. We <br className='hidden md:block' /> build your <span className='font-bold'>capability</span></p>
                        </div>
                        <div className='mt-[10px] md:mt-[20px] md:w-[450px]  mx-auto xl:ml-[10px] xl:mr-0'>
                            <button className='bg-[#34C759] h-[40px] md:h-[56px] w-full rounded-[10px] md:rounded-[14px] text-[18px] md:text-[25px] font-semibold text-[#FFF]'
                                onClick={() => {
                                    const slotDiv = document.getElementById("slot");
                                    if (slotDiv) {
                                        slotDiv.scrollIntoView({ behavior: "smooth", block: "start" });
                                    }
                                }}
                            >Join now ₹499</button>
                            <div className='flex gap-[6px] font-medium text-[10px] md:text-[14px] justify-center items-center w-full mt-[10px]'>
                                <LuShield size={12} className='text-[#34C759]' />
                                <p className='text-[#6A7282] font-medium'>100% student first 7 day refund guarantee</p>
                            </div>
                        </div>
                    </div>
                    <div className='flex flex-col justify-center items-end relative mt-3 lg:mt-12 xl:mt-0'>
                        <div className='relative z-[0] w-[95%] object-cover sm:h-auto sm:w-10/12 rounded-[10px] mx-auto'>
                            <img src={banner} alt='background' className='rounded-[10px] relative z-0' loading='lazy' />
                        </div>
                        <div className='w-full sm:w-11/12 mx-auto bg-[#FFF] rounded-[10px] md:rounded-[20px] border border-[#8080804D] flex flex-row justify-between items-center -mt-16 relative z-10 py-[8px] md:py-[16px]' style={{ boxShadow: "4px 8px 17px 0px #0000001F" }}>
                            <div className='basis-1/4 flex justify-between'>
                                <div></div>
                                <div className='flex flex-col justify-center items-center gap-[5px] md:gap-[10px]'>
                                    <div className='flex justify-center items-center bg-[#FFEDD4] size-[40px] md:size-[52px] rounded-[8px] md:rounded-[14px] text-[#F54900]'>
                                        <LuTable2 className='text-[20px] md:text-[24px]' />
                                    </div>
                                    <p className='font-semibold text-[#000000] text-[10px] md:text-[18px]'>Clarity</p>
                                </div>
                                <div className='h-[80px] my-auto w-[1px] bg-[#C6C6C8] rounded-full flex-shrink-0'></div>
                            </div>
                            <div className='basis-1/4 flex justify-between'>
                                <div></div>
                                <div className='flex flex-col justify-center items-center gap-[10px]'>
                                    <div className='flex justify-center items-center bg-[#DBEAFE] size-[40px] md:size-[52px] rounded-[8px] md: text-[#155DFC]'>
                                        <LuTrendingUp className='text-[20px] md:text-[24px]' />
                                    </div>
                                    <p className='font-semibold text-[#000000] text-[10px] md:text-[18px]'>Confidence</p>
                                </div>
                                <div className='h-[80px] my-auto w-[1px] bg-[#C6C6C8] rounded-full flex-shrink-0'></div>
                            </div>
                            <div className='basis-1/4 flex justify-between'>
                                <div></div>
                                <div className='flex flex-col justify-center items-center gap-[10px]'>
                                    <div className='flex justify-center items-center bg-[#F3E8FF] size-[40px] md:size-[52px] rounded-[8px] md: text-[#9810FA]'>
                                        <LuZap className='text-[20px] md:text-[24px]' />
                                    </div>
                                    <p className='font-semibold text-[#000000] text-[10px] md:text-[18px]'>Capability</p>
                                </div>
                                <div className='h-[80px] my-auto w-[1px] bg-[#C6C6C8] rounded-full flex-shrink-0'></div>
                            </div>
                            <div className='basis-1/4 flex justify-between'>
                                <div></div>
                                <div className='flex flex-col justify-center items-center gap-[10px]'>
                                    <div className='flex justify-center items-center bg-[#DCFCE7] size-[40px] md:size-[52px] rounded-[8px] md: text-[#00A63E]'>
                                        <LuCircleCheckBig className='text-[20px] md:text-[24px]' />
                                    </div>
                                    <p className='font-semibold text-[#000000] text-[10px] md:text-[18px]'>Identity</p>
                                </div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
